<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon style="font-size: 56px; height: 60px; width: 60px;">dashboard</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'blog.blog' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search1" autocomplete="off" matInput>
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
  </div>
  <!-- / SEARCH -->

  @if (!isReadOnly) {
    <button mat-raised-button
      [routerLink]="'/pages/blog/new'"
      class="add-product-button mat-white-bg my-12 mt-sm-0">
      <span>{{'blog.add_new' | translate}}</span>
    </button>
  }
</div>
<!-- / HEADER -->
    <mat-sidenav-container class="my-sidenav" style="  position: absolute;
    width: 210px;
    height: calc(100vh - 210px);
    right: 0;
    z-index: 999;
    top: 136px;
    background: transparent;">
  <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
                   fuseMatSidenavHelper="sidenav" mat-is-locked-open="gt-sm" [ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;
    width: 100%;
    margin: 0px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    overflow: hidden;
    transform: none;
    visibility: visible;">
    <filter-menu [filters]="filterData" [page]="'blog'"
    (chooseFilter)="chooseFilters($event)"></filter-menu>
  </mat-sidenav>
</mat-sidenav-container>
<!-- CONTENT CARD -->
<div class="content-card mat-white-bg"
  [ngClass]="{'margin-big-screen': sidenav.opened}">
  <div class="blogs">
    @for (block of aboutBlocks; track block) {
      <div class="block">
        @if (block.type !== 'custom') {
          <blog-block [info]="block"></blog-block>
        }
        @if (block.type === 'custom') {
          <new-blog [info]="block"></new-blog>
        }
        <div class="hover-div" [routerLink]="'/pages/blog/detail'" [queryParams]="{id: block.id}"></div>
      </div>
    }
  </div>
  <mat-paginator #paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="[6, 12, 24]"
    [pageIndex]="pageIndex"
    [length]="totalCount"
  (page)="changePageEmitter($event)"></mat-paginator>

</div>
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>



